import React, { useState, useEffect, useRef } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import "./FormPhoneInput.css";
const FormPhoneInput = ({
  value,
  onChange,
  name = "phone",
  id = "phone",
  label = "Phone",
  placeholder = "Phone",
  inputStyle = { height: "55px", width: "100%" },
  required = true,
  readOnly = false,
  initialCountry = "tr",
  lockCountry = false,
}) => {
  const { t } = useTranslation();
  const [internalPhone, setInternalPhone] = useState(value || "");
  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const countryWasSelected = useRef(false);

  // Eğer dışarıdan bir değer geliyorsa, içeriği güncelle
  const phoneValue = value !== undefined ? value : internalPhone;
  const setPhoneValue = onChange !== undefined ? onChange : setInternalPhone;

  useEffect(() => {
    if (value !== undefined) {
      setInternalPhone(value);
    }
  }, [value]);

  // IP ülkesini kullan; servis erişilemezse initialCountry zaten güvenli varsayılandır.
  useEffect(() => {
    if (readOnly || value) return undefined;

    let active = true;
    const browserCountry =
      typeof navigator !== "undefined"
        ? navigator.language?.split("-")[1]?.toLowerCase()
        : "";
    if (browserCountry && !countryWasSelected.current) {
      setSelectedCountry(browserCountry);
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2500);

    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const countryCode = data?.country_code?.toLowerCase();
        if (active && countryCode && !countryWasSelected.current) {
          setSelectedCountry(countryCode);
        }
      })
      .catch(() => {})
      .finally(() => clearTimeout(timeoutId));

    return () => {
      active = false;
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, [readOnly, value]);

  const handlePhoneChange = (value, data) => {
    const dialCode = data.dialCode;

    // Eğer numara kısmı silindiyse, sadece ülke kodu sabit kalsın
    if (value.replace(dialCode, "").length === 0) {
      setPhoneValue(dialCode); // Sadece ülke kodunu sabitle
      return;
    }

    // Eğer ülke kodu seçilmediyse, numara kısmını koruyarak sadece ülke kodunu ekleyelim
    if (!value.startsWith(dialCode)) {
      value = dialCode + value.replace(/\D/g, "").replace(dialCode, "");
    }

    const phoneNumberWithoutDialCode = value.replace(dialCode, "");

    if (phoneNumberWithoutDialCode.length > 0) {
      setPhoneValue(dialCode + phoneNumberWithoutDialCode); // Dial kodu korunur, sadece numara değişir
    } else {
      setPhoneValue(dialCode); // Numara boşsa, sadece dialCode sabit kalır
    }

    // Eğer onChange fonksiyonu varsa, bunu çağırıyoruz
    if (onChange) {
      onChange(dialCode + phoneNumberWithoutDialCode); // Güncellenen numarayı gönderiyoruz
    }
  };

  const handleCountryChange = (countryCode) => {
    if (lockCountry) return;
    countryWasSelected.current = true;
    setSelectedCountry(countryCode || initialCountry);
  };

  return (
    <div className="col-lg-12 form-phone-input">
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <PhoneInput
        country={selectedCountry || initialCountry}
        value={phoneValue}
        onChange={handlePhoneChange}
        onCountryChange={handleCountryChange}
        enableSearch
        searchPlaceholder={t("Arama")}
        inputProps={{
          name,
          id,
          placeholder: t(placeholder),
          required,
        }}
        inputStyle={inputStyle} // Dışarıdan stil verebilme
        disabled={readOnly}
      />
    </div>
  );
};

export default FormPhoneInput;
